/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingCompanyIdentityResource
 */
export interface BillingCompanyIdentityResource {
    /**
     * 
     * @type {string}
     * @memberof BillingCompanyIdentityResource
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BillingCompanyIdentityResource
     */
    registrationNumbers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BillingCompanyIdentityResource
     */
    vatNumber?: string;
}

/**
 * Check if a given object implements the BillingCompanyIdentityResource interface.
 */
export function instanceOfBillingCompanyIdentityResource(value: object): value is BillingCompanyIdentityResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('registrationNumbers' in value) || value['registrationNumbers'] === undefined) return false;
    return true;
}

export function BillingCompanyIdentityResourceFromJSON(json: any): BillingCompanyIdentityResource {
    return BillingCompanyIdentityResourceFromJSONTyped(json, false);
}

export function BillingCompanyIdentityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingCompanyIdentityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'registrationNumbers': json['registrationNumbers'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
    };
}

export function BillingCompanyIdentityResourceToJSON(value?: BillingCompanyIdentityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'registrationNumbers': value['registrationNumbers'],
        'vatNumber': value['vatNumber'],
    };
}

